import { SlideConfig } from '../types';

/**
 * Mapping da slide ID a benefit config key (legacy; flusso VPP non usa header benefici)
 */
export const SLIDE_TO_BENEFIT_KEY: Record<string, string> = {
  decision_stage: 'install_timeline',
  name_form: 'name_form',
  email_form: 'email_form',
  phone_form: 'phone_form',
};

/**
 * Configurazione delle slide del wizard SliderBonuscasaVpp
 * Flusso VPP: kW → batteria → contatti → success
 */
const ICON_YES =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Ccircle cx='12' cy='12' r='12' fill='%2322c55e'/%3E%3Cpath fill='%23fff' d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'/%3E%3C/svg%3E";

const ICON_NO =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23ef4444'/%3E%3Cpath fill='%23fff' d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3C/svg%3E";

export const SLIDES_CONFIG: SlideConfig[] = [
  {
    id: 'vpp_plant_kw',
    type: 'FORM_INPUT',
    title: 'Inserisci i KW del tuo Impianto Fotovoltaico',
    inputs: [
      {
        name: 'vpp_plant_kw',
        placeholder: 'Es. 6',
        type: 'tel',
        required: true,
        pattern: '^\\d+(\\.\\d+)?$',
      },
    ],
  },

  {
    id: 'vpp_battery',
    type: 'SINGLE_ANSWER',
    title: 'Il tuo impianto ha una batteria di accumulo?',
    apiFieldName: 'vpp_battery',
    autoAdvance: true,
    answers: [
      { label: 'Sì', value: 'yes', image: ICON_YES },
      { label: 'No', value: 'no', image: ICON_NO },
    ],
  },

  {
    id: 'vpp_contact',
    type: 'FORM_INPUT',
    title: 'Ricevi la simulazione dei ricavi',
    inputs: [
      { name: 'name', placeholder: 'Nome e cognome', type: 'text', required: true },
      { name: 'email', placeholder: 'Il tuo indirizzo email', type: 'email', required: true },
      {
        name: 'phone',
        placeholder: 'Numero di cellulare',
        type: 'tel',
        required: true,
        pattern: '^[\\d\\s]{10,18}$',
      },
    ],
  },

  {
    id: 'success',
    type: 'INFO',
    title: '',
  },
];

export const getSlideIndexById = (id: string): number => {
  return SLIDES_CONFIG.findIndex((slide) => slide.id === id);
};

export const BENEFIT_SLIDE_IDS = [
  'decision_stage',
  'name_form',
  'email_form',
  'phone_form',
] as const;

export const PROGRESS_SLIDE_IDS = SLIDES_CONFIG
  .filter((slide) => slide.type === 'SINGLE_ANSWER' || slide.type === 'FORM_INPUT')
  .map((slide) => slide.id);

export function getBenefitKeyForSlide(slideId: string): string {
  return SLIDE_TO_BENEFIT_KEY[slideId] || slideId;
}

export function getBenefitShortName(benefitText: string | null): string {
  if (!benefitText) return 'il prossimo Beneficio';

  const text = benefitText.toLowerCase();

  if (text.includes('bolletta')) return 'il Risparmio in Bolletta';
  if (text.includes('surplus')) return 'il Surplus CER';
  if (text.includes('rivendita') && !text.includes('surplus')) return 'la Rivendita Energia';
  if (text.includes('ecobonus')) return "l'Ecobonus";
  if (text.includes('pnrr') || text.includes('cer enpal')) return 'il PNRR CER Enpal';
  if (text.includes('conto termico')) return 'il Conto Termico';
  if (text.includes('bonus regione fvg')) return 'il Bonus Regione FVG';
  if (text.includes('risparmio totale')) return 'il Risparmio Totale';

  return 'il prossimo Beneficio';
}
